import moment from "moment/moment";
import i18n from "../i18n";

export const joinClass = (...classNames) => classNames.join(" ");

export const getItemFromLocalStorage = (id) =>
  JSON.parse(localStorage.getItem(id));

export const setItemToLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getFormatedDate = (timestamp) =>
  new Date(+timestamp).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

export const moveInArray = (arr, from, to) => {
  const newArr = arr.slice();
  const item = newArr.splice(from, 1);
  newArr.splice(to, 0, item[0]);

  return newArr;
};

export const timeDifference = (current, previous) => {
  var msPerMinute = 60 * 1000;
  var msPerHour = msPerMinute * 60;
  var msPerDay = msPerHour * 24;
  var msPerMonth = msPerDay * 30;
  var msPerYear = msPerDay * 365;

  var elapsed = current - previous;

  if (elapsed < msPerMinute) {
    return Math.round(elapsed / 1000) + " seconds ago";
  } else if (elapsed < msPerHour) {
    return Math.round(elapsed / msPerMinute) + " minutes ago";
  } else if (elapsed < msPerDay) {
    return Math.round(elapsed / msPerHour) + " hours ago";
  } else if (elapsed < msPerMonth) {
    return "approximately " + Math.round(elapsed / msPerDay) + " days ago";
  } else if (elapsed < msPerYear) {
    return "approximately " + Math.round(elapsed / msPerMonth) + " months ago";
  } else {
    return "approximately " + Math.round(elapsed / msPerYear) + " years ago";
  }
};

export const removeUnderScore = (word = "") => {
  const arrayString = word.split("_");
  return arrayString
    .map((str) => str.charAt(0).toUpperCase() + str.slice(1))
    .join(" ");
};

export const sort = (element1, element2) => {
  const nameA = element1.name?.toLowerCase();
  const nameB = element2.name?.toLowerCase();
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};

export const filteredDepartmentList = (departmentList, type, cssdEnabled) => {
  let newList = departmentList;
  if (cssdEnabled) {
    newList = departmentList.filter((department) => department.cssd_enabled);
  }

  if (type === "owner") {
    newList = newList.filter((el) => el.asset_owner);
  } else if (type === "custodian") {
    newList = newList.filter((el) => el.asset_custodian);
  } else if (type === "all") {
    newList = (cssdEnabled && newList) || departmentList;
  }
  const sorted = newList.sort((element1, element2) => sort(element1, element2));
  return sorted;
};

export const handleSpeak = (value, synthRef, endFn) => {
  if (synthRef.current) {
    synthRef.current.cancel();
  }
  synthRef.current = window.speechSynthesis;
  var voices = synthRef.current.getVoices();
  const utter = new SpeechSynthesisUtterance();
  utter.voice = voices[2];
  utter.volume = 1;

  if (endFn) {
    utter.onend = (event) => {
      endFn();
    };
  }
  utter.text = value;
  synthRef.current.speak(utter);
};
export const timeListGenerator = (
  initialHour,
  initialMinute,
  initialMeridiem,
  isFullList
) => {
  let hour = initialHour;
  let minute = initialMinute;
  let meridiem = initialMeridiem;
  let timeList = [];

  const formatTime = (time) => (time < 10 ? `0${time}` : time.toString());

  const makeRequiredFormat = (hour, minute, meridiem) =>
    `${formatTime(hour)}:${formatTime(minute)} ${meridiem}`;

  if (hour > 12) hour = hour - 12;

  for (let i = 0; i < 1439; i++) {
    if (minute === 59) {
      if (hour === 12 && meridiem === "PM") {
        hour = 1;
        minute = 0;
        meridiem = "PM";
      } else if (hour === 11 && meridiem === "AM") {
        hour = 12;
        minute = 0;
        meridiem = "PM";
      } else if (hour === 11 && meridiem === "PM") {
        hour = 0;
        minute = 0;
        meridiem = "AM";
      } else if (hour === 12 && meridiem === "AM") {
        hour = 1;
        minute = 0;
        meridiem = "AM";
      } else {
        hour = hour + 1;
        minute = 0;
      }
    } else minute = minute + 1;

    if (isFullList) {
      timeList.push({
        label: makeRequiredFormat(hour, minute, meridiem),
        value: makeRequiredFormat(hour, minute, meridiem),
        show: minute % 15 === 0 ? true : false,
      });
    } else {
      if (minute % 15 === 0)
        timeList.push({
          label: makeRequiredFormat(hour, minute, meridiem),
          value: makeRequiredFormat(hour, minute, meridiem),
        });
    }
  }

  return timeList;
};

export const repeatElementByCount = (count, Element) => {
  return [...Array(count)].map((e, i) => <Element key={i} />);
};

export const updateTimeOfDay = () => {
  const currentHour = new Date().getHours();

  if (currentHour < 12) {
    return "GOOD_MORNING";
  } else if (currentHour < 16) {
    return "GOOD_AFTERNOON";
  } else {
    return "GOOD_EVENING";
  }
};

export const convertToDuration = (value) => {
  let tempTime = moment.duration(value);
  const hr = tempTime.hours() > 0 ? `${tempTime.hours()}${i18n.t("hr")}` : "";
  const min =
    tempTime.minutes() > 0 ? `${tempTime.minutes()}${i18n.t("min")}` : "";

  return hr === "" && min === "" ? "0" : `${hr} ${min}`;
};

export const convertToDurationTest = (value) => {
  let tempTime = moment.duration(value * 60000);

  const hr = tempTime.hours() > 0 ? `${tempTime.hours()}${i18n.t("hr")}` : "";
  const min =
    tempTime.minutes() > 0 ? `${tempTime.minutes()}${i18n.t("min")}` : "";

  return hr === "" && min === "" ? "0" : `${hr} ${min}`;
};
